import { useEffect } from "react";
import { TaskTypesNavigation } from "../../components/TaskTypeComponents/TaskTypesNavigation";
import { Stage } from "../../components/StageComponents/Stage";
import { useParams, useNavigate, Outlet } from "react-router-dom";
import { useTaskTypeByBoardId } from "../../data/queries/taskTypeQueries";
import { TaskTypeBoardHeader } from "../../components/TaskTypeComponents/TaskTypeBoardHeaderComponents/TaskTypeBoardHeader";
import { TaskTypeBackLink } from "../../components/TaskTypeComponents/TaskTypeBoardHeaderComponents/TaskTypeBackLink";

export const TaskTypesLayout = () => {
  const navigate = useNavigate();
  const { boardId, taskTypeId } = useParams();
  const { data: taskTypes } = useTaskTypeByBoardId(boardId);

  useEffect(() => {
    if (taskTypes && taskTypes.length > 0 && !taskTypeId && boardId) {
      navigate(
        `/duedates/settings/boards/${boardId}/tasktypes/${taskTypes[0]?.Id}`
      );
    }
  }, [taskTypes, boardId, navigate]);

  // if (isPending) return null;
  // Can't conditionally return null on react router page elements
  // it causes issues when cache is flushed and page is reloaded.
  // Bug #113076 - Due Dates - Board Settings - Error page when Reload Empty Cache

  return (
    <div className="et-tasktype-layout h-100">
      <div className="container-fluid d-flex flex-column h-100">
        <div className="row et-task-type-back">
          <TaskTypeBackLink />
        </div>
        <div className="row">
          <div className="col et-task-type-header mb-3 w-100">
            <TaskTypeBoardHeader boardId={boardId} />
          </div>
        </div>
        <div className="row d-flex flex-fill h-100 pb-4">
          <div className="d-flex p-0">
            <div className="col-2 et-task-types-nav">
              <div className="side-bar-container active">
                <TaskTypesNavigation boardId={boardId} taskTypes={taskTypes} />
              </div>
            </div>
            <div className="col-8 task-types-layout module-layout-content">
              {taskTypes && taskTypes.length > 0 ? (
                <Outlet />
              ) : (
                <div className="empty-row"></div>
              )}
            </div>
            <div className="d-flex col-2">
              <Stage />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
